import { connect } from 'react-redux';
import { List } from 'immutable';
import moment from 'moment';
import {
  loadCognitoForm,
  updateCognitoForm,
  createCognitoForm,
  deleteCognitoForm,
  cognitoFormsFormDestroy,
} from '../../../../../state/modules/cognitoForms/actions';
import CognitoFormForm from '../components/CognitoFormForm';
import Config from '../../../../../Config';

const inputs = List([
  'form_id',
  'form_key',
  'name',
  'public_status',
  'type',
  'registration_code',
  'registration_code_id',
  'profile',
  'user_profile_id',
  'status',
  'partnership_id',
  'cognito_forms_care_guide_partner_tags',
  'new_user_requirement',
  'old_user_requirement',
  'old_user_requirement_frequency_type',
  'old_user_requirement_repeat_every',
  'old_user_requirement_repeat_unit',
]);

const mapStateToProps = (state, ownProps) => {
  const data = {},
    errors = {};

  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['cognitoForms', ownProps.id, val], '');
    errors[val] = state.cognitoForms.getIn(['form', 'errors', val]);
  }

  // change select number values to strings to work with ant design select inputs
  Object.keys(data).forEach((x) => {
    if (['status'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  data['uploaded_at'] = data['uploaded_at']
    ? moment(data['uploaded_at'], Config.get('API_DATETIME_FORMAT'))
    : moment();

  data['type'] = data['type'] !== '' ? data['type'] : 1;

  data['public_status'] =
    data['public_status'] !== '' ? data['public_status'] : 1;

  data['cognito_forms_care_guide_partner_tags'] =
    data['cognito_forms_care_guide_partner_tags'] !== ''
      ? data['cognito_forms_care_guide_partner_tags']
      : [];

  return {
    isLoading: state.cognitoForms.get('isLoading'),
    isSubmitting: state.cognitoForms.getIn(['form', 'isSubmitting']),
    success: state.cognitoForms.getIn(['form', 'success']),
    created_id: state.cognitoForms.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(
      ['cognitoForms', ownProps.id, 'created_at'],
      null
    ),
    updatedAt: state.entities.getIn(
      ['cognitoForms', ownProps.id, 'updated_at'],
      null
    ),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (id, cb) => {
      dispatch(loadCognitoForm(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateCognitoForm(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createCognitoForm(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteCognitoForm(id, cb));
    },
    destroyForm: (formState) => {
      dispatch(cognitoFormsFormDestroy(formState));
    },
  };
};

const CognitoFormFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormForm);

export default CognitoFormFormContainer;
